import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { Sparkles, Lock, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Паролата трябва да е поне 6 символа");
    if (password !== confirm) return toast.error("Паролите не съвпадат");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Паролата е сменена успешно");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] p-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm bg-white border border-slate-100 rounded-3xl p-8 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <div className="bg-sky-500 text-white p-2 rounded-2xl"><Sparkles size={20} /></div>
          <span className="font-heading font-black text-xl text-slate-900">УчителAI</span>
        </div>

        {!token ? (
          <div className="text-center py-6">
            <p className="text-slate-500">Линкът за смяна на паролата е невалиден или непълен.</p>
            <button data-testid="reset-back-btn" onClick={() => navigate("/")}
              className="mt-6 w-full bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 rounded-full transition-colors">Към входа</button>
          </div>
        ) : done ? (
          <div className="text-center py-4">
            <CheckCircle2 size={44} className="text-emerald-500 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-bold text-slate-900">Готово!</h1>
            <p className="text-slate-500 mt-2 text-sm">Паролата Ви е сменена успешно. Вече можете да влезете с новата парола.</p>
            <button data-testid="reset-login-btn" onClick={() => navigate("/")}
              className="mt-6 w-full bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 rounded-full transition-colors">Влез в профила</button>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-black text-slate-900">Нова парола</h1>
            <p className="text-slate-500 mt-1.5 text-sm">Задайте нова парола за Вашия профил.</p>
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div className="relative">
                <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-300" />
                <input data-testid="reset-password-input" required type="password" placeholder="Нова парола" value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-sky-300 outline-none" />
              </div>
              <div className="relative">
                <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-300" />
                <input data-testid="reset-confirm-input" required type="password" placeholder="Потвърди паролата" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-sky-300 outline-none" />
              </div>
              <button data-testid="reset-submit-btn" disabled={loading}
                className="w-full bg-sky-500 hover:bg-sky-600 text-white font-bold py-3 rounded-full transition-colors disabled:opacity-60">
                {loading ? "Моля изчакайте..." : "Смени паролата"}
              </button>
            </form>
          </>
        )}
      </motion.div>
    </div>
  );
}
